import React, { useEffect, useState} from 'react';
import { Modal } from 'antd';
import { Button } from "@vds/buttons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useDispatch } from 'react-redux';
import { setCurrentModal } from '../store/actions/alertsGroup';
import { updateUI } from "../store/actions/shipment";
import { updateUI as updateDeviceProfileUI } from "../store/actions/deviceProfile";
const CustomModal = ({modalKey, popupName, popupTitle, buttonName, customClass, open, children, handler}) => {
  const dispatch = useDispatch();
  const showLoading = (e) => {
    if(handler){
      e.preventDefault();
      handler()
    }
  };
  const enhancedChildren = React.cloneElement(children, );

  const handleCancel = () => {
    if (modalKey === 'shipment') {
      dispatch(
        updateUI({
          key: 'delete',
          value: {
            singleDelete: !open,
            deletedField: {
              id: '',
              name: '',
            },
          },
        })
      );
    } else if (modalKey === 'bulkDeleteShipConfirmed') {
      dispatch(
        updateUI({
          key: "delete",
          value: {
            bulkDelete: false,
          },
        })
      );
    } else if (modalKey === 'deleteprofile') {
      dispatch(
        updateDeviceProfileUI({
          key: "delete",
          value: {
            isOpen: false,
            id: null,
            name: "",
          },
        })
      );
    } else {
      dispatch(setCurrentModal(''));
    }
  };

  return (
    <>
      <Modal
        footer={null}
        open={open}
        onCancel={handleCancel}
        className={customClass}
      >

        <div style={{ marginBottom: "10px" }}>
          <h2 className={"font-face-vzb page-heading-user"}>
              {popupName}
          </h2>
          <h4 className={"font-face-vzb page-sub-heading-user"} style={{fontSize:'32px',lineHeight:'36px',marginTop:'19px'}}>
            {popupTitle}
          </h4>
        </div>
          {enhancedChildren}
      </Modal>
    </>
  );
};

export default CustomModal;